<template>
  <div>
    <Toolbar >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-update</v-icon>{{ item['id'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-updatedlynxapi-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('updatedlynxapi.start') }}</strong></td>
              <td>
                {{ formatDateTime(item['start'], 'long') }}              </td>

              <td><strong>{{ $t('updatedlynxapi.end') }}</strong></td>
              <td>
                {{ formatDateTime(item['end'], 'long') }}              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'UpdatedLynxapi';

export default {
  name: 'UpdatedLynxapiShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin],
  computed: {
    ...mapFields('updatedlynxapi', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('updatedlynxapi', ['find'])
  },
  methods: {
    ...mapActions('updatedlynxapi', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
